import {Component, Input} from "@angular/core";

@Component({
  selector: 'kng-bubble-tip-icon',
  templateUrl: './kng-bubble-tip-icon.component.html',
  styleUrls: []
})
export class KngBubbleTipIconComponent {

  @Input()
  public placement: string = '';

  @Input()
  public message: string = '';

  constructor() { }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/layout/kingswell/kng-bubble-tip/kng-bubble-tip-icon.component.ts